import axiosapi from "./axiosAPI";

// Get All Tribes
export const getAllTribes = async (
    setTribes,
    setFetcherror,
    setIsLoading
) => {
    
    
	try{
		const res =await axiosapi.get("/tribes");
        setTribes(res.data.data ? res.data.data : {});
        setIsLoading(false);

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Tribes");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Tribes");
		}
		
	}
	
};



// Get One Tribe
export const getOneTribe = async (
    pkid,
    setFetcherror,  
    setTribe
    
)=>{
	try{
		const res =await axiosapi.get(`/tribes/${pkid}`);
        setTribe(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Tribe");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Tribe");
		}
		
	}
	
};


// Create New Tribe
export const createTribe = async (
    tribe,
    setTribe,
    setFetcherror,
    handleAllToasts,
    setTribes

) => {



    if (!tribe ) {
        handleAllToasts(2, "No Tribe Provided"); 
            return; 
        }

    const PushItem = {
            name: tribe,
        };

    try{
        await axiosapi.post("/tribes/",PushItem );
        setTribe("");
        handleAllToasts(1, "Tribe Created Successfully");
        getAllTribes(setTribes,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Tribe");
            handleAllToasts(2, "Could Not update The Tribe");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Tribe");
            handleAllToasts(2, "Could Not update The Tribe");
            
        }
        
    }
    
}


// Edit Existing Tribe

export const editTribe = async (
    tribepkid,
    tribe,
    setTribe,
    setFetcherror,
    handleAllToasts,
    setTribes
              
        ) => {

            if (!tribe) {
                handleAllToasts(2, "No Tribe Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:tribepkid,
                    name: tribe,
                };

            try{
                await axiosapi.patch("/tribes/",PushItem );
                setTribe("");
                handleAllToasts(1, "Tribe Updated Successfully");
                getAllTribes(setTribes,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Tribe");
                    handleAllToasts(2, "Could Not Update Tribe");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Tribe");
                    handleAllToasts(2, "Could Not Update Tribe");
                    
                }
                
            }
            
};



// Delete Existing Tribe.

export const deleteTribe = async (
    tribepkid,
    setTribes,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/tribes/${tribepkid}`);
        let finalData = res.data.message;
        getAllTribes(setTribes, setFetcherror);
        handleAllToasts(1, "Tribe Deleted Successfully");
        console.log("Deleted:", finalData);
        getAllTribes(setTribes,setFetcherror);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Tribe");
            handleAllToasts(2,"Error: Could Not Delete Tribe");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Tribe");
            handleAllToasts(2,"Error: Could Not Delete Tribe");
		}
		
	}
	
};